import { setupLayouts } from 'virtual:meta-layouts'
import { createRouter, createWebHistory } from 'vue-router/auto'

function recursiveLayouts(route) {
  if (route.children) {
    for (let i = 0; i < route.children.length; i++)
      route.children[i] = recursiveLayouts(route.children[i])
    
    return route
  }
  
  return setupLayouts([route])[0]
}

const resolveHistoryBase = () => {
  if (typeof window !== 'undefined') {
    const baseHref = document.querySelector('base')?.getAttribute('href')

    if (baseHref) {
      try {
        return new URL(baseHref, window.location.origin).pathname || '/'
      }
      catch {
        if (baseHref.startsWith('/'))
          return baseHref
      }
    }
  }

  return '/'
}

const router = createRouter({
  history: createWebHistory(resolveHistoryBase()),
  scrollBehavior(to) {
    if (to.hash)
      return { el: to.hash, behavior: 'smooth', top: 60 }
    
    return { top: 0 }
  },
  extendRoutes: pages => [
    ...[...pages].map(route => recursiveLayouts(route)),
  ],
})

const CHUNK_RELOAD_STORAGE_KEY = 'starter-kit:chunk-reload-attempted'
const CHUNK_LOAD_ERROR_PATTERN = /Failed to fetch dynamically imported module|Importing a module script failed/i

if (typeof window !== 'undefined') {
  router.onError((error, to) => {
    const message = String(error?.message || '')
    if (!CHUNK_LOAD_ERROR_PATTERN.test(message))
      return

    const alreadyAttempted = window.sessionStorage.getItem(CHUNK_RELOAD_STORAGE_KEY) === '1'
    if (!alreadyAttempted) {
      window.sessionStorage.setItem(CHUNK_RELOAD_STORAGE_KEY, '1')
      window.location.assign(to?.fullPath || window.location.href)

      return
    }

    window.sessionStorage.removeItem(CHUNK_RELOAD_STORAGE_KEY)
    console.error('Chunk reload failed after automatic retry', error)
  })

  router.afterEach(() => {
    window.sessionStorage.removeItem(CHUNK_RELOAD_STORAGE_KEY)
  })
}

export { router }
export default function (app) {
  app.use(router)
}
